// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchBox[data-v-41021925] .ant-form-item-children {\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
